import { Chip, ChipProps } from '@mui/material';
import React from 'react';
import { styled } from '@/theme/index';

const StyledBadge = styled(Chip)`
  &.badge {
    border-radius: 4px;
  }

  &.corner-tag {
    border-radius: 0;
    border-bottom-left-radius: 4px;
  }

  &.left-tag {
    border-radius: 0;
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
  }
`;

export const Pill: React.FC<ChipProps> = React.forwardRef(
  (props: ChipProps, ref) => {
    return <StyledBadge {...props} ref={ref} />;
  }
);
